import axios from 'axios'

export const pythonApi = axios.create({
  baseURL: (window.location.href.includes("test") || window.location.href.includes("casaeterra")) ? "http://177.93.108.106:5000" : "http://177.93.108.106:5000"
})
export const api = axios.create({
  baseURL: "http://177.93.108.106:3003"
})